export default [
  {
    value: "1",
    label: "Contributions are deductible",
  },
  {
    value: "2",
    label: "Contributions are not deductible",
  },
  {
    value: "4",
    label: "Contributions are eductible by treaty (foreign organizations)",
  },
];
